import AbsComponent from "../../common/AbsComponent";

/**
* Recommend class
* @category main
*/
class Recommend extends AbsComponent{
    constructor(_store={}, _el=''){
        super(_store, _el);

        this.setting();
    }

    setting(){
        const slickOption = {
            dots: true,
            infinite: true,
            speed: 300,
            autoplay: true,
            autoplaySpeed: 5000,
            slidesToShow: 2,
            slidesToScroll: 2,
            responsive: [
                {
                    breakpoint: 4000,
                    settings: {
                        arrows: true,
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        arrows: false,
                    }
                }
            ]
        };
        $(this.el + ' .recommended-product-list').on('init', function(event, slick){
            console.log('Slick 슬라이더가 초기화!');
            /** @type {HTMLElement} */ 
            const el = document.querySelector('.recommended-product-list');
            el.style.visibility = 'visible';
        });

        $(this.el + ' .recommended-product-list').slick(slickOption);
    }
} // end of class
export default Recommend;